import React, { useState } from 'react';
import api from '../services/api';
import { Button } from './ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/dropdown-menu';
import { Download, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

/**
 * Reusable export button that fetches a file from a /reports/* endpoint
 * and triggers a browser download.
 */
const ExportButton = ({ endpoint, filename = 'export', params = {}, label = 'Export', testId = 'export-btn' }) => {
  const [busy, setBusy] = useState(false);

  const handle = async (format) => {
    setBusy(true);
    try {
      const res = await api.get(endpoint, {
        params: { ...params, format },
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.download = `${filename}.${format}`;
      link.click();
      window.URL.revokeObjectURL(url);
      toast.success(`Downloaded ${format.toUpperCase()}`);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Export failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" disabled={busy} data-testid={testId}>
          {busy ? <Loader2 size={14} className="animate-spin mr-2" /> : <Download size={14} className="mr-2" />}
          {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="z-50">
        <DropdownMenuItem onClick={() => handle('xlsx')} data-testid={`${testId}-xlsx`}>Excel (.xlsx)</DropdownMenuItem>
        <DropdownMenuItem onClick={() => handle('csv')} data-testid={`${testId}-csv`}>CSV (.csv)</DropdownMenuItem>
        <DropdownMenuItem onClick={() => handle('pdf')} data-testid={`${testId}-pdf`}>PDF (.pdf)</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ExportButton;
